<template>
  <section
    v-if="hasMapOrLink || (viewer?.is_owner && ownerViewMode)"
    class="border-t border-white/10 font-t3-display"
    id="location"
    aria-label="Location"
  >
    <div class="max-w-7xl mx-auto">
      <div v-if="hasMapOrLink" class="w-full h-[320px] sm:h-[400px] flex flex-col items-center justify-center bg-t3-accent-dark relative overflow-hidden">
        <div class="absolute inset-0 z-10">
          <PublicRestaurantMap
            :show-owner-map-hint="viewer?.is_owner === true"
            :restaurant="restaurant"
            container-class="h-[320px] sm:h-[400px] w-full rounded-2xl overflow-hidden"
            link-class="bg-t3-primary text-t3-bg-dark hover:bg-t3-primary/90 font-bold text-sm py-2 px-4 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-t3-primary focus-visible:ring-offset-2 focus-visible:ring-offset-t3-bg-dark"
          />
        </div>
      </div>
      <div v-else-if="viewer?.is_owner && ownerViewMode" class="py-8 px-4">
        <div class="max-w-md mx-auto py-4 px-4 rounded border border-dashed border-white/30 bg-white/10">
          <p class="text-sm font-mono text-slate-300">{{ $t('public.noMapSetOwnerMessage') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import PublicRestaurantMap from '@/components/public/PublicRestaurantMap.vue'
import { restaurantHasMapOrLink } from '@/utils/googleMapsUrl'

const props = defineProps({
  restaurant: { type: Object, default: () => ({}) },
  viewer: { type: Object, default: () => ({ is_owner: false }) },
  ownerViewMode: { type: Boolean, default: true },
})

const hasMapOrLink = computed(() => restaurantHasMapOrLink(props.restaurant))
</script>
